import { render } from "./App.vue?vue&type=template&id=53923ea4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Layout/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53923ea4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53923ea4', __exports__)) {
    console.log('reload')
    api.reload('53923ea4', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=53923ea4", () => {
    console.log('re-render')
    api.rerender('53923ea4', render)
  })

}


export default __exports__